"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var OriginalSuspense = React.Suspense;
function Suspense(_ref) {
  var key = _ref.key,
    children = _ref.children,
    rest = (0, _objectWithoutProperties2["default"])(_ref, ["key", "children"]);
  return typeof document !== 'undefined' ? /*#__PURE__*/React.createElement(OriginalSuspense, (0, _extends2["default"])({
    key: key
  }, rest), children) : /*#__PURE__*/React.createElement(React.Fragment, {
    key: key
  }, children);
}
var _default = Suspense;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9TdXNwZW5zZS5qcyJdLCJuYW1lcyI6WyJPcmlnaW5hbFN1c3BlbnNlIiwiUmVhY3QiLCJTdXNwZW5zZSIsImtleSIsImNoaWxkcmVuIiwicmVzdCIsImRvY3VtZW50Il0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7QUFBQTs7QUFFQSxJQUFNQSxnQkFBZ0IsR0FBR0MsS0FBSyxDQUFDQyxRQUEvQjs7QUFFQSxTQUFTQSxRQUFULE9BQThDO0FBQUEsTUFBMUJDLEdBQTBCLFFBQTFCQSxHQUEwQjtBQUFBLE1BQXJCQyxRQUFxQixRQUFyQkEsUUFBcUI7QUFBQSxNQUFSQyxJQUFRO0FBQzVDLFNBQU8sT0FBT0MsUUFBUCxLQUFvQixXQUFwQixnQkFDTCxvQkFBQyxnQkFBRDtBQUFrQixJQUFBLEdBQUcsRUFBRUg7QUFBdkIsS0FBZ0NFLElBQWhDLEdBQ0dELFFBREgsQ0FESyxnQkFLTCxvQkFBQyxLQUFELENBQU8sUUFBUDtBQUFnQixJQUFBLEdBQUcsRUFBRUQ7QUFBckIsS0FBMkJDLFFBQTNCLENBTEY7QUFPRDs7ZUFFY0YsUSIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCAqIGFzIFJlYWN0IGZyb20gJ3JlYWN0J1xuXG5jb25zdCBPcmlnaW5hbFN1c3BlbnNlID0gUmVhY3QuU3VzcGVuc2VcblxuZnVuY3Rpb24gU3VzcGVuc2UoeyBrZXksIGNoaWxkcmVuLCAuLi5yZXN0IH0pIHtcbiAgcmV0dXJuIHR5cGVvZiBkb2N1bWVudCAhPT0gJ3VuZGVmaW5lZCcgPyAoXG4gICAgPE9yaWdpbmFsU3VzcGVuc2Uga2V5PXtrZXl9IHsuLi5yZXN0fT5cbiAgICAgIHtjaGlsZHJlbn1cbiAgICA8L09yaWdpbmFsU3VzcGVuc2U+XG4gICkgOiAoXG4gICAgPFJlYWN0LkZyYWdtZW50IGtleT17a2V5fT57Y2hpbGRyZW59PC9SZWFjdC5GcmFnbWVudD5cbiAgKVxufVxuXG5leHBvcnQgZGVmYXVsdCBTdXNwZW5zZVxuIl19
void function register() {
  /* react-hot-loader/webpack */var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;
  if (!reactHotLoader) {
    return;
  } /* eslint-disable camelcase, no-undef */
  var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : exports; /* eslint-enable camelcase, no-undef */
  if (!webpackExports) {
    return;
  }
  if (typeof webpackExports === 'function') {
    reactHotLoader.register(webpackExports, 'module.exports', "/home/runner/work/shoutout_site/shoutout_site/node_modules/react-static/lib/Suspense.js");
    return;
  } /* eslint-disable no-restricted-syntax */
  for (var key in webpackExports) {
    /* eslint-enable no-restricted-syntax */if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) {
      continue;
    }
    var namedExport = void 0;
    try {
      namedExport = webpackExports[key];
    } catch (err) {
      continue;
    }
    reactHotLoader.register(namedExport, key, "/home/runner/work/shoutout_site/shoutout_site/node_modules/react-static/lib/Suspense.js");
  }
}();